module.exports = __webpack_public_path__ + "static/media/om_beard_medium_round__oval_vector.fe0b7197.svg";